import { useTranslation } from "../../utils/hooks/useTranslation";
import { useEventsListContext } from "./EventFilterContext";
import { CalendarInput } from "./CalendarInput";
import { sift } from "radash";
import { FrontendLocale } from "@libry-content/localization";
import { localizedFormat } from "../../utils/date";
import { Facets } from "../filter/FacetFilters";
import { FilterTag } from "../filter/FilterTag";

export const EventFacetButtons = () => {
  const { toggleFacet, facets, isValidating, urlState, setDateFilter, finishedOrUnfinishedEvents } =
    useEventsListContext();
  const { t, lang } = useTranslation();
  const fromDate = urlState?.from;
  const toDate = urlState?.to;

  const dateRange =
    finishedOrUnfinishedEvents === "unfinished"
      ? {
          start: new Date(),
        }
      : {
          end: new Date(),
        };

  const relevantDateFilter = finishedOrUnfinishedEvents === "unfinished" ? "from" : "to";
  const onChangeDate = (date: string | undefined) => relevantDateFilter && setDateFilter(relevantDateFilter, date);

  if (!facets) return null;

  const fromDateTag = fromDate && (
    <FilterTag
      filter={{ label: t("Fra {dato}", { dato: getDateString(fromDate, lang) }), value: fromDate }}
      onClick={() => setDateFilter("from", undefined)}
    />
  );

  const toDateTag = toDate && (
    <FilterTag
      filter={{ label: t("Til {dato}", { dato: getDateString(toDate, lang) }), value: toDate }}
      onClick={() => setDateFilter("to", undefined)}
    />
  );

  const dateFilterTags = sift([fromDateTag, toDateTag]);

  const dateFacet = {
    label: t("Dato"),
    component: <CalendarInput value={urlState?.from} onChange={onChangeDate} dateRange={dateRange} />,
    filterTags: dateFilterTags,
  };

  return <Facets facets={facets} toggleFacet={toggleFacet} isValidating={!!isValidating} customFacets={[dateFacet]} />;
};

const getDateString = (date: string, lang: FrontendLocale) => localizedFormat(date, "PPP", lang);
